import type { Step } from "react-joyride";
import type { NavigateFunction } from "react-router-dom";

export function getWalkthroughSteps(navigate: NavigateFunction): Step[] {
  return [
    {
      target: "body",
      placement: "center",
      title: "Welcome to RoleWeave!",
      content:
        "This quick tour will introduce you to the main features of the platform. " +
        "You can skip at any time and restart it later from your Profile page.",
      skipBeacon: true,
    },
    {
      target: "#tour-logo",
      title: "The Header",
      content: "Click the RoleWeave logo at any time to return to your Dashboard.",
      skipBeacon: true,
    },
    {
      target: "#tour-nav-home",
      title: "Hearth",
      content:
        "Your Hearth shows a summary of your entries, chronicles, heroes, and sessions at a glance.",
      skipBeacon: true,
      before: () => {
        navigate("/protected/home");
        return new Promise((resolve) => setTimeout(resolve, 300));
      },
    },
    {
      target: "#tour-nav-assets",
      title: "Compendium",
      content:
        "Build your world here. Create and organise NPCs, locations, items, factions, and any other " +
        "lore objects you need for your chronicles. You can reference entries using the '[[' notation.",
      skipBeacon: true,
      before: () => {
        navigate("/protected/assets");
        return new Promise((resolve) => setTimeout(resolve, 300));
      },
    },
    {
      target: "#tour-nav-campaigns",
      title: "Chronicles",
      content:
        "Create chronicles, invite companions, import entries from your Compendium, and run collaborative session logs — " +
        "all in one place.",
      skipBeacon: true,
      before: () => {
        navigate("/protected/campaigns");
        return new Promise((resolve) => setTimeout(resolve, 300));
      },
    },
    {
      target: "#tour-nav-characters",
      title: "Heroes",
      content: "Manage hero backgrounds, portraits, and fate formulas.",
      skipBeacon: true,
      before: () => {
        navigate("/protected/characters");
        return new Promise((resolve) => setTimeout(resolve, 300));
      },
    },
    {
      target: "#tour-user-menu",
      title: "Your Account",
      content:
        "Click here to access your Weaver Profile settings or sign out. " +
        "You can also restart this tour from the Weaver Profile page at any time.",
      skipBeacon: true,
      before: () => {
        navigate("/protected/user/profile");
        return new Promise((resolve) => setTimeout(resolve, 300));
      },
      after: () => navigate("/protected/home"),
    },
  ];
}
